import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const slider = document.querySelector(
  ".product-variant-picker__variants-dropdown .swiper"
);

if (slider) {
  const swiper = new Swiper(slider, {
    modules: [Navigation],
    loop: false,
    slidesPerView: "auto",
    mousewheel: {
      enabled: true,
      sensitivity: 0.5,
      forceToAxis: true,
    },
    freeMode: {
      enabled: true,
      momentum: true, 
    },
    spaceBetween: 10,
    navigation: {
      nextEl: ".product-variant-picker__variants-dropdown__header__next",
      prevEl: ".product-variant-picker__variants-dropdown__header__prev",
    },
  });

  // Handle trackpad horizontal scrolling fluidly
  slider.addEventListener('wheel', (e) => {
    if (e.deltaX !== 0) {
      e.preventDefault(); // Prevent vertical scrolling

      const scrollAmount = e.deltaX * 0.4; // Adjust multiplier for fluidity
      let newTranslate = swiper.getTranslate() - scrollAmount;

      // Boundary check: Prevent scrolling beyond the first and last slide
      const maxTranslate = 0; // The start of the swiper (left boundary)
      const minTranslate = -swiper.virtualSize + swiper.width; // The end of the swiper (right boundary)

      // Ensure newTranslate doesn't exceed the swiper bounds
      if (newTranslate > maxTranslate) {
        newTranslate = maxTranslate; // Stop at the start
      } else if (newTranslate < minTranslate) {
        newTranslate = minTranslate; // Stop at the end
      }

      swiper.setTranslate(newTranslate); // Apply the calculated translation
    }
  }, { passive: false });

  const headers = document.querySelectorAll(
    ".product-variant-picker__list-header"
  );
  const iconChevron = document.querySelector(".accordeon__icon");
  const groupItems = document.querySelectorAll(
    ".product-variant-picker__variants-dropdown__group__item__button"
  );
  const productLists = document.querySelectorAll(
    ".product-variant-picker__variants-dropdown__group__item__list__inner"
  );
  
  headers.forEach((header) => {
    const dropdown = header.nextElementSibling;
  
    header.addEventListener("click", function () {
      dropdown.classList.toggle("lbc-visible");
      iconChevron.classList.toggle("lbc-chevron-rotate");
      header.classList.toggle("lbc-half-radius");
    });
  });
  
  if (groupItems) {
    groupItems.forEach((item) => {
      item.addEventListener("click", function () {
        groupItems.forEach((i) =>
          i.classList.remove(
            "product-variant-picker__variants-dropdown__group__item__button--selected"
          )
        );
  
        this.classList.add(
          "product-variant-picker__variants-dropdown__group__item__button--selected"
        );
  
        productLists.forEach((list) =>
          list.classList.remove(
            "product-variant-picker__variants-dropdown__group__item__list__inner--active"
          )
        );
  
        const groupId = this.getAttribute("data-group-id");
        document
          .querySelector(
            `.product-variant-picker__variants-dropdown__group__item__list__inner[data-group-id="${groupId}"]`
          )
          .classList.add(
            "product-variant-picker__variants-dropdown__group__item__list__inner--active"
          );
      });
    });
  }
  
  if (groupItems.length > 0) {
    groupItems[0].click();
  } 
}




